import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import HeroBanner from "../components/hero-banner"

export default ({ data }) => (
  <Layout footerFacebookLink="https://www.facebook.com/traleemarathonkerry">
    <SEO title="Tralee Race Series" description="We host a series of races in the beautiful town of Tralee, Co. Kerry." />
    <HeroBanner
      bgImage={data.image1.childImageSharp.fluid}
      title="Welcome to the Tralee Race Series"
      subTitle="Unforgettable races through the stunning landscape of Tralee, Co. Kerry."
      plainSubtitle
    />
    <section className="welcome">
      <div className="container-width">
        <div className="readable-width">
          <p>Our carefully planned courses guide you through Tralee's historic streets and into the breathtaking Kerry countryside. You'll be supported by the incredible energy of our local community every step of the way, making for a truly memorable race day.</p>
          <p>We offer a full range of distances, from a welcoming 5K to our challenging ultra-marathons, ensuring there's a perfect race for every ambition.</p>
          <p><strong>Explore our events, find your next challenge, and join us for a celebration of running.</strong></p>
          <p>— The Tralee Race Series team</p>
        </div>
      </div>
    </section>
  </Layout>
)

export const query = graphql`
  query {
    image1: file(relativePath: { eq: "tralee-race-series-001.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
